module.exports = __webpack_public_path__ + "static/media/profile-picture-4.ccd796b3.jpg";